module.exports = __webpack_public_path__ + "static/Terms-publish-program-f1b1124a8b995bfad3373adb523a4bd7.pdf";